import React, { useState } from 'react';
import AddonDrawer from './addonDrawer';
import './addonService.scss';
import { connect } from 'react-redux';
import currencyFormatter from 'currency-formatter';

const AddonServiceSelection = ({
  addonServices,
  onSetAddOnServicesSelected,
  totalAddonFee,
  currencyISO = 'USD',
  isEditFare = false,
  disabled = false,
  customUiTotalAddonFee,
  auth
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      {addonServices?.length > 0 && (
        <>
          {customUiTotalAddonFee ? (
            <div onClick={() => setOpen(true)}>{customUiTotalAddonFee}</div>
          ) : (
            <button
              className="addon-open-btn"
              type="button"
              onClick={() => setOpen(true)}
              // disabled={disabled}
            >
              {currencyFormatter.format(totalAddonFee || 0, {
                code: currencyISO,
              })}
            </button>
          )}
          <AddonDrawer
            open={open}
            disabled={disabled}
            onClose={() => setOpen(false)}
            addonServices={addonServices}
            onSetAddOnServicesSelected={onSetAddOnServicesSelected}
            isEditFare={isEditFare}
            currencyISO={currencyISO}
            auth={auth}
          />
        </>
      )}
    </>
  );
};

export default connect(mapStateToProps, null)(AddonServiceSelection);

function mapStateToProps(state) {
  return {
    auth: state.auth,
  };
}
